import React, { useEffect, useState } from "react";
import { getAllAllowance } from "../../api/allowanceApi";
import { getAllDeduction } from "../../api/deductionApi";

const Step6SalaryStructure = ({ formData, handleChange, nextStep, prevStep }) => {
  const [allowances, setAllowances] = useState([]);
  const [deductions, setDeductions] = useState([]);

  const grossSalary = parseFloat(formData.grossSalary || 0);
  const includePT = formData.calculatePT === "Y";
  const includePF = formData.calculatePF === "Y";

  const setGrossSalary = (val) => handleChange("grossSalary")({ target: { value: val } });
  const setIncludePT = (val) => handleChange("calculatePT")({ target: { value: val ? "Y" : "N" } });
  const setIncludePF = (val) => handleChange("calculatePF")({ target: { value: val ? "Y" : "N" } });

  const toNumber = (value) => parseFloat(value);

  // Calculate Allowances
  const calculatedAllowances = allowances.map((item) => ({
    ...item,
    amount: (grossSalary * item.percentage) / 100,
  }));

  const totalAllowance = calculatedAllowances.reduce((sum, a) => sum + a.amount, 0);

  // const basicAllowance = calculatedAllowances.find(
  //   (a) => a.allowanceName.toLowerCase() === "basic"
  // );

  // Always treat first allowance as "Basic" for PF calculation
  const basicAllowance = calculatedAllowances.length > 0 ? calculatedAllowances[0] : null;

  // Calculate deductions for UI (with PT slab logic)
  const calculatedDeductions = deductions.map((item, index) => {
    // const isPT = item.deductionName.toLowerCase() === "pt";
    // const isPF = item.deductionName.toLowerCase().includes("pf");

    const isPF = index === 0; // 1st deduction = PF
    const isPT = index === 2; // 3rd deduction = PT

    const isIncluded =
      (isPT && includePT) ||
      (isPF && includePF) ||
      (!isPT && !isPF);

    let amount = 0;

    if (isIncluded) {
      if (isPT && includePT) {
        // PT Slab logic
        if (totalAllowance <= 7500) {
          amount = 0;
        } else if (totalAllowance > 7500 && totalAllowance <= 10000) {
          amount = 175;
        } else {
          amount = 200;
        }
      } else if (isPF && includePF) {
          //use basicAllowance here
        amount = ((basicAllowance?.amount || 0) * item.percentage) / 100;
      } else {
        // other percentage-based deductions
        amount = (grossSalary * item.percentage) / 100;
      }
    }

    return { ...item, amount };
  });

  const totalDeduction = calculatedDeductions.reduce((sum, d) => sum + d.amount, 0);
  const netSalary = grossSalary - totalDeduction;
  const perDaySalary = grossSalary / 30;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const allowanceData = await getAllAllowance();
        const deductionData = await getAllDeduction();
        setAllowances(allowanceData);
        setDeductions(deductionData);

        // Calculate Allowances for saving
        const calculatedAllowances = allowanceData.map((item) => ({
          ...item,
          amount: (grossSalary * item.percentage) / 100,
        }));

        // Build allowance object sequentially
        const allowanceObject = {};
        calculatedAllowances.forEach((a, index) => {
          allowanceObject[`allowance${index + 1}`] = a.amount.toFixed(2);
        });

        handleChange("allowance")({
          target: { value: allowanceObject }
        });

        // const basicAllowance = calculatedAllowances.find(
        //   (a) => a.allowanceName.toLowerCase() === "basic"
        // );

        // Always treat first allowance as "Basic" for PF calculation
        const basicAllowance = calculatedAllowances.length > 0 ? calculatedAllowances[0] : null;

        // Calculate total allowance
        const totalAllowance = calculatedAllowances.reduce((sum, a) => sum + a.amount, 0);

        // Calculate Deductions with PT slab logic for saving
        const calculatedDeductions = deductionData.map((item, index) => {
          // const isPT = item.deductionName.toLowerCase() === "pt";
          // const isPF = item.deductionName.toLowerCase().includes("pf");

          const isPF = index === 0; // 1st deduction = PF
          const isPT = index === 2; // 3rd deduction = PT

          const isIncluded =
            (isPT && includePT) ||
            (isPF && includePF) ||
            (!isPT && !isPF);

          let amount = 0;

          if (isIncluded) {
            if (isPT && includePT) {
              // PT Slab logic
              if (totalAllowance <= 7500) {
                amount = 0;
              } else if (totalAllowance > 7500 && totalAllowance <= 10000) {
                amount = 175;
              } else {
                amount = 200;
              }
            } else if (isPF && includePF) {
              // PF should be on Basic, not Gross
              amount = (basicAllowance?.amount || 0) * item.percentage / 100;
            } else {
              // other percentage-based deductions
              amount = (grossSalary * item.percentage) / 100;
            }
          }

          return { ...item, amount };
        });

        //  Now build deduction object
        const deductionObject = {};
        calculatedDeductions.forEach((d, index) => {
          deductionObject[`deduction${index + 1}`] = parseFloat(d.amount.toFixed(2));
        });

        handleChange("deduction")({
          target: { value: deductionObject }
        });

        const totalDeduction = calculatedDeductions.reduce((sum, d) => sum + d.amount, 0);
        const netSalary = grossSalary - totalDeduction;
        const perDaySalary = grossSalary / 30;

        // Save values
        handleChange("totalAllow")({ target: { value: totalAllowance.toFixed(2) } });
        handleChange("totalDeduction")({ target: { value: totalDeduction.toFixed(2) } });
        handleChange("netSalary")({ target: { value: netSalary.toFixed(2) } });
        handleChange("perDaySalary")({ target: { value: parseFloat(perDaySalary.toFixed(2)) } });

        if (basicAllowance) {
          handleChange("basicSalary")({ target: { value: basicAllowance.amount.toFixed(2) } });
        }
      } catch (error) {
        console.error("Error fetching salary data", error);
      }
    };

    fetchData();
  }, [grossSalary, includePT, includePF]);
//style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}
  return (
    <div className="container mt-4">
      <div className="container mt-4">
        {/* Gross Salary Input */}
        <div className="card mb-4">
          <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
            <span>Gross Salary Input</span>
            <span>
              {formData.fName} {formData.lName}
            </span>
          </div>
          <div className="card-body row g-3">
            <div className="col-md-4">
              <label>Gross Salary</label>
              <input
                type="number"
                className="form-control"
                value={grossSalary}
                onChange={(e) => setGrossSalary(toNumber(e.target.value))}
              />
            </div>
          </div>
        </div>

        {/* Allowances Section */}
        <div className="card mb-4">
          {/* <div className="card-header bg-success text-white">Allowances</div> */}
          <div className="card-header bg-success text-white d-flex justify-content-between align-items-center">
          <span>Allowances</span>
          <span>
            {formData.fName} {formData.lName}
          </span>
        </div>
          <div className="card-body row g-3">
            {calculatedAllowances.map((item, index) => (
              <div className="col-md-4" key={`allowance-${index}`}>
                <label>{item.allowanceName} ({item.percentage}%)</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={item.amount.toFixed(2)}
                  disabled
                />
              </div>
            ))}
          </div>
        </div>

        {/* Deductions Section */}
        <div className="card mb-4">
          {/* <div className="card-header bg-danger text-white">Deductions</div> */}
          <div className="card-header bg-danger text-white d-flex justify-content-between align-items-center">
          <span>Deductions</span>
          <span>
            {formData.fName} {formData.lName}
          </span>
        </div>
          <div className="card-body row g-3">
            {calculatedDeductions.map((item, index) => {
              // const isPT = item.deductionName.toLowerCase().includes("pt");
              // const isPF = item.deductionName.toLowerCase().includes("pf");

              const isPF = index === 0; // 1st deduction = PF
              const isPT = index === 2; // 3rd deduction = PT

              return (
                <div className="col-md-4 d-flex align-items-center" key={`deduction-${index}`}>
                  <div className="w-100">
                    <label className="d-flex align-items-center justify-content-between">
                      {item.deductionName} ({item.percentage}%)
                      {(isPT || isPF) && (
                        <input
                          type="checkbox"
                          className="form-check-input ms-2"
                          checked={isPT ? includePT : includePF}
                          onChange={() => isPT ? setIncludePT(!includePT) : setIncludePF(!includePF)}
                        />
                      )}
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm mt-1"
                      value={item.amount.toFixed(2)}
                      disabled
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Summary Section */}
        <div className="card mb-4">
          {/* <div className="card-header bg-secondary text-white">Salary Summary</div> */}
          <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
          <span>Salary Summary</span>
          <span>
            {formData.fName} {formData.lName}
          </span>
        </div>
          <div className="card-body row g-3">
            <div className="col-md-3">
              <label>Total Allowance</label>
              <input className="form-control" value={totalAllowance.toFixed(2)} disabled />
            </div>
            <div className="col-md-3">
              <label>Total Deduction</label>
              <input className="form-control" value={totalDeduction.toFixed(2)} disabled />
            </div>
            <div className="col-md-3">
              <label>Net Salary</label>
              <input className="form-control" value={netSalary.toFixed(2)} disabled />
            </div>
            <div className="col-md-3">
              <label>Per Day Salary</label>
              <input className="form-control" value={perDaySalary.toFixed(2)} disabled />
            </div>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="d-flex justify-content-between">
          <button className="btn btn-secondary" onClick={prevStep}>Back</button>
          <button className="btn btn-primary" onClick={nextStep}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default Step6SalaryStructure;



//Without PT deduction

// import React, { useEffect, useState } from "react";
// import { getAllAllowance } from "../../api/allowanceApi";
// import { getAllDeduction } from "../../api/deductionApi";

// const Step6SalaryStructure = ({ formData, handleChange, nextStep, prevStep }) => {
//   const [allowances, setAllowances] = useState([]);
//   const [deductions, setDeductions] = useState([]);
  
//   const grossSalary = parseFloat(formData.grossSalary || 0);
//   const includePT = formData.calculatePT === "Y";
//   const includePF = formData.calculatePF === "Y";

//   const setGrossSalary = (val) => handleChange("grossSalary")({ target: { value: val } });
//   const setIncludePT = (val) => handleChange("calculatePT")({ target: { value: val ? "Y" : "N" } });
//   const setIncludePF = (val) => handleChange("calculatePF")({ target: { value: val ? "Y" : "N" } });


//   const toNumber = (value) => parseFloat(value) ;

//   // Calculate Allowances and Deductions based on Gross Salary
//   const calculatedAllowances = allowances.map((item) => ({
//     ...item,
//     amount: (grossSalary * item.percentage) / 100,
//   }));

//   const calculatedDeductions = deductions.map((item) => {
//   const isPT = item.deductionName.toLowerCase().includes("pt");
//   const isPF = item.deductionName.toLowerCase().includes("pf");

//   const isIncluded = 
//     (isPT && includePT) ||
//     (isPF && includePF) ||
//     (!isPT && !isPF); // For all other types of deductions

//   return {
//     ...item,
//     amount: isIncluded ? (grossSalary * item.percentage) / 100 : 0,
//   };
// });

//   const totalAllowance = calculatedAllowances.reduce((sum, a) => sum + a.amount, 0);
//   const totalDeduction = calculatedDeductions.reduce((sum, d) => sum + d.amount, 0);
//   const netSalary = grossSalary - totalDeduction;
//   const perDaySalary = grossSalary / 30;

//   useEffect(() => {
//   const fetchData = async () => {
//     try {
//       const allowanceData = await getAllAllowance();
//       const deductionData = await getAllDeduction();
//       setAllowances(allowanceData);
//       setDeductions(deductionData);

//       // Calculate Allowances
//       const calculatedAllowances = allowanceData.map((item) => ({
//         ...item,
//         amount: (grossSalary * item.percentage) / 100,
//       }));

//       // Build allowance object sequentially
//       const allowanceObject = {};
//       calculatedAllowances.forEach((a, index) => {
//         allowanceObject[`allowance${index + 1}`] = a.amount.toFixed(2);
//       });

//       // Update formData.allowance
//       handleChange("allowance")({
//         target: { value: allowanceObject }
//       });

//       // Find Basic Allowance
//       const basicAllowance = calculatedAllowances.find(
//         (a) => a.allowanceName.toLowerCase() === "basic"
//       );

//       // Calculate Deductions
//       const calculatedDeductions = deductionData.map((item) => {
//         const isPT = item.deductionName.toLowerCase().includes("pt");
//         const isPF = item.deductionName.toLowerCase().includes("pf");

//         const isIncluded = 
//           (isPT && includePT) ||
//           (isPF && includePF) ||
//           (!isPT && !isPF);

//         return {
//           ...item,
//           amount: isIncluded ? (grossSalary * item.percentage) / 100 : 0,
//         };
//       });

//       // Build deduction object sequentially
//       const deductionObject = {};
//       calculatedDeductions.forEach((d, index) => {
//         deductionObject[`deduction${index + 1}`] = parseFloat(d.amount.toFixed(2));
//       });

//       // Update formData.deduction
//       handleChange("deduction")({
//         target: { value: deductionObject }
//       });
      
//       const totalAllowance = calculatedAllowances.reduce((sum, a) => sum + a.amount, 0);
     
//       const totalDeduction = calculatedDeductions.reduce((sum, d) => sum + d.amount, 0);
//       const netSalary = grossSalary - totalDeduction;
//       const perDaySalary = grossSalary / 30;

//       // Save values to formData
//       handleChange("totalAllow")({ target: { value: totalAllowance.toFixed(2) } });
//       handleChange("totalDeduction")({ target: { value: totalDeduction.toFixed(2) } });
//       handleChange("netSalary")({ target: { value: netSalary.toFixed(2) } });
//       handleChange("perDaySalary")({ target: { value: parseFloat(perDaySalary.toFixed(2)) } });

//       if (basicAllowance) {
//         handleChange("basicSalary")({ target: { value: basicAllowance.amount.toFixed(2) } });
//       }
//     } catch (error) {
//       console.error("Error fetching salary data", error);
//     }
//   };

//   fetchData();
// }, [grossSalary, includePT, includePF]);

//   return (
//     <div className="container mt-4" style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}>
//       <div className="container mt-4">
//         {/* Gross Salary Input */}
//         <div className="card mb-4">
//           <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
//             <span>Gross Salary Input</span>
//             <span>
//               {formData.fName} {formData.lName}
//             </span>
//             </div>
//           <div className="card-body row g-3">
//             <div className="col-md-4">
//               <label>Gross Salary</label>
//               <input
//                 type="number"
//                 className="form-control"
//                 value={grossSalary}
//                 onChange={(e) => setGrossSalary(toNumber(e.target.value))}
//               />
//             </div>
//           </div>
//         </div>

//         {/* Allowances Section */}
//         <div className="card mb-4">
//           <div className="card-header bg-success text-white">Allowances</div>
//           <div className="card-body row g-3">
//             {calculatedAllowances.map((item, index) => (
//               <div className="col-md-4" key={`allowance-${index}`}>
//                 <label>{item.allowanceName} ({item.percentage}%)</label>
//                 <input
//                   type="number"
//                   className="form-control form-control-sm"
//                   value={item.amount.toFixed(2)}
//                   disabled
//                 />
//               </div>
//             ))}
//           </div>
//         </div>


//         {/* Deductions Section */}
//         <div className="card mb-4">
//           <div className="card-header bg-danger text-white">Deductions</div>
//           <div className="card-body row g-3">
//             {calculatedDeductions.map((item, index) => {
//               const isPT = item.deductionName.toLowerCase().includes("pt");
//               const isPF = item.deductionName.toLowerCase().includes("pf");
            
//               return (
//                 <div className="col-md-4 d-flex align-items-center" key={`deduction-${index}`}>
//                   <div className="w-100">
//                     <label className="d-flex align-items-center justify-content-between">
//                       {item.deductionName} ({item.percentage}%)
//                       {(isPT || isPF) && (
//                         <input
//                           type="checkbox"
//                           className="form-check-input ms-2"
//                           checked={isPT ? includePT : includePF}
//                           onChange={() => isPT ? setIncludePT(!includePT) : setIncludePF(!includePF)}
//                         />
//                       )}
//                     </label>
//                     <input
//                       type="number"
//                       className="form-control form-control-sm mt-1"
//                       value={item.amount.toFixed(2)}
//                       disabled
//                     />
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
          

//         {/* Summary Section */}
//         <div className="card mb-4">
//           <div className="card-header bg-secondary text-white">Salary Summary</div>
//           <div className="card-body row g-3">
//             <div className="col-md-3">
//               <label>Total Allowance</label>
//               <input className="form-control" value={totalAllowance.toFixed(2)} disabled />
//             </div>
//             <div className="col-md-3">
//               <label>Total Deduction</label>
//               <input className="form-control" value={totalDeduction.toFixed(2)} disabled />
//             </div>
//             <div className="col-md-3">
//               <label>Net Salary</label>
//               <input className="form-control" value={netSalary.toFixed(2)} disabled />
//             </div>
//             <div className="col-md-3">
//               <label>Per Day Salary</label>
//               <input className="form-control" value={perDaySalary.toFixed(2)} disabled />
//             </div>
//           </div>
//         </div>

//         {/* Navigation Buttons */}
//         <div className="d-flex justify-content-between">
//           <button className="btn btn-secondary" onClick={prevStep}>Back</button>
//           <button className="btn btn-primary" onClick={nextStep}>Next</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Step6SalaryStructure;

